<mat-card class="p-0 fx-flex-100" *ngIf="style === 'expanded'">
  <div class="p-16 fx-row fx-wrap align-items-center justify-content-between main-bg">
    <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-100">
      <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100">
        <div class="fx-column fx-flex">
          <span class="small white fx-flex-100 ">{{(scoreType == 'global' ? 'CASE.SCORE.GLOBAL' : 'CASE.SCORE.CLASS') |
            translate:getClass()}}</span>
          <app-animated-number [value]="100*score.global" [class]="'huge white'" [unit]="'%'"></app-animated-number>
        </div>

        <div class="chip white outline clickable" [cdkMenuTriggerFor]="menu" #trigger="cdkMenuTriggerFor">
          {{'CASE.SCORE.TYPE_SELECTOR' | translate}}: {{((scoreType == 'global' ? 'CASE.SCORE.TYPE_GLOBAL' :
          'CASE.SCORE.TYPE_CLASS') | translate:getClass(scoreType)).toLowerCase()}}
        </div>
        <ng-template #menu>
          <mat-card class="menu-container p-0 elevation" cdkMenu>
            <div class="p-8">
              <span class="text dark bold fx-flex-100">{{'CASE.SCORE.TYPE_SELECTOR' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="fx-row fx-wrap justify-content-start align-items-center p-8 clickable option"
              [class.selected]="scoreType == st" *ngFor="let st of scoreTypes" (click)="onScoreTypeChange(st)">
              <span class="text dark fx-flex-100">{{(st == 'global' ? 'CASE.SCORE.TYPE_GLOBAL' :
                'CASE.SCORE.TYPE_CLASS') | translate:getClass(st)}}</span>
            </div>
          </mat-card>
        </ng-template>
      </div>


      <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-100">
        <div class="fx-row align-items-center justify-content-start score-container white fx-flex-100">
          <div class="score white" [style.flex-basis.%]="100*score.global">
          </div>
        </div>
      </div>
      <div class="fx-row align-items-center justify-content-start mt-10">
        <mat-icon class="mr-10 white" fontSet="material-icons-outlined">{{tip('global').icon}}</mat-icon>
        <span class="text white fx-flex">{{tip('global').message}}</span>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="fx-row fx-wrap align-items-stretch justify-content-start border-bottom ">
    <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-50 border-right border-box p-16">
      <span class="small light fx-flex-100 ">{{'CASE.SCORE.DOCUMENTS_COUNT' | translate}}</span>
      <span class="text bold main  fx-flex-100 ">{{(100*score.documentsCount).toFixed(0)}}%</span>
      <div class="fx-row align-items-center justify-content-start score-container fx-flex-100">
        <div class="score" [style.flex-basis.%]="100*score.documentsCount">
        </div>
      </div>
      <div class="fx-row align-items-center justify-content-start mt-5">
        <mat-icon class="mr-10" [class]="tip('documentsCount').color"
          fontSet="material-icons-outlined">{{tip('documentsCount').icon}}</mat-icon>
        <span class="small fx-flex">{{tip('documentsCount').message}}</span>
      </div>
    </div>
    <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-50 border-box p-16">
      <span class="small light fx-flex-100 ">{{'CASE.SCORE.DOCUMENTS_ACCURACY' | translate}}</span>
      <span class="text bold main  fx-flex-100 ">{{(100*score.documentsAccuracy).toFixed(0)}}%</span>
      <div class="fx-row align-items-center justify-content-start score-container fx-flex-100">
        <div class="score" [style.flex-basis.%]="100*score.documentsAccuracy">
        </div>
      </div>
      <div class="fx-row align-items-center justify-content-start mt-5">
        <mat-icon class="mr-10" [class]="tip('documentsAccuracy').color"
          fontSet="material-icons-outlined">{{tip('documentsAccuracy').icon}}</mat-icon>
        <span class="small fx-flex">{{tip('documentsAccuracy').message}}</span>
      </div>
    </div>
  </div>
  <div class="fx-row fx-wrap align-items-stretch justify-content-start">
    <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-50  border-right border-box p-16">
      <span class="small light fx-flex-100 ">{{'CASE.SCORE.DOCUMENTS_TYPES' | translate}}</span>
      <span class="text bold main  fx-flex-100 ">{{(100*score.documentsClasses).toFixed(0)}}%</span>
      <div class="fx-row align-items-center justify-content-start score-container fx-flex-100">
        <div class="score" [style.flex-basis.%]="100*score.documentsClasses">
        </div>
      </div>
      <div class="fx-row align-items-center justify-content-start mt-5">
        <mat-icon class="mr-10" [class]="tip('documentsClasses').color"
          fontSet="material-icons-outlined">{{tip('documentsClasses').icon}}</mat-icon>
        <span class="small fx-flex">{{tip('documentsClasses').message}}</span>
      </div>
    </div>
    <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-50 border-box  p-16">
      <span class="small light fx-flex-100 ">{{'CASE.SCORE.TEMPORAL_COVERAGE' | translate}}</span>
      <span class="text bold main  fx-flex-100">{{(100*score.temporalCoverage).toFixed(0)}}%</span>
      <div class="fx-row align-items-center justify-content-start score-container fx-flex-100">
        <div class="score" [style.flex-basis.%]="100*score.temporalCoverage">
        </div>
      </div>
      <div class="fx-row align-items-center justify-content-start mt-5">
        <mat-icon class="mr-10" [class]="tip('temporalCoverage').color"
          fontSet="material-icons-outlined">{{tip('temporalCoverage').icon}}</mat-icon>
        <span class="small fx-flex">{{tip('temporalCoverage').message}}</span>
      </div>
    </div>
  </div>
</mat-card>
<div class="fx-row fx-wrap" *ngIf="style === 'condensed'">
  <div class="fx-row fx-wrap align-items-baseline justify-content-between fx-flex-100">
    <span class="text" [class]="color">{{'CASE.SCORE.TITLE' | translate}}</span>
    <app-animated-number [value]="100*score.global" [class]="'text bold '+color" [unit]="'%'"></app-animated-number>
  </div>

  <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-100">
    <div class="fx-row align-items-center justify-content-start score-container fx-flex-100" [class]="color">
      <div class="score" [class]="color" [style.flex-basis.%]="100*score.global">
      </div>
    </div>
  </div>
</div>